import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FaClock } from 'react-icons/fa';
import { getDashboardTodayAct } from '../../../redux/MainAction';

const WeekActivity = () => {
  const dispatch = useDispatch();
  const [firstRefresh, setFirstRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const convertSeconds = (seconds) => {
    const isNegative = seconds < 0;
    const absSeconds = Math.abs(seconds);
    const hours = Math.floor(absSeconds / 3600);
    const minutes = Math.floor((absSeconds % 3600) / 60);
    const remainingSeconds = absSeconds % 60;
    return `${isNegative ? '-' : ''}${hours}h : ${minutes}m : ${remainingSeconds}s`;
  };

  const todayAct = useSelector(
    (state) => state.Webtracker.dashboardTodayActivity
  );

  const [filters, setFilters] = useState('TODAY');

  const onChangeRange = async (e) => {
    const range = e.target.value;
    setIsLoading(true);
    setFirstRefresh(true);
    setFilters(range);

    await dispatch(
      getDashboardTodayAct({
        range,
      })
    );

    setIsLoading(false);
  };

  async function fetchDashboardData(isFirstRefresh) {
    setIsLoading(true);
    if (isFirstRefresh) setFirstRefresh(true);

    await dispatch(getDashboardTodayAct({ range: 'TODAY' }));

    setIsLoading(false);
  }

  return (
    <div className="col-6">
      <div className="card  m-b-20 enhanced-card">
        <div className="border_class d-flex align-items-center justify-content-between">
          <h5 className="dash-card-title font-20 ml-3">All Activities</h5>
        </div>
        <div className="card-body dash_cards act_card1">
          <div className="d-flex justify-content-between align-items-center m-b-20">
            <h4
              className=" header-title d-flex align-items-center"
              style={{ color: '#23486A', fontSize: '18px' }}
            >
              <FaClock className="mr-1 font-18 dash-text-primary" /> Today's
              Activity
            </h4>
            <select
              className="form-control"
              style={{
                border: 'none',
                width: '115px',
                cursor: 'pointer',
                backgroundColor: '#f9fbfe',
              }}
              value={filters}
              onChange={onChangeRange}
            >
              <option value="TODAY">Today </option>
              <option value="THIS-WEEK">This Week</option>
            </select>
          </div>

          {isLoading ? (
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="spinner-border text-primary " role="status"></div>
            </div>
          ) : firstRefresh ? (
            <div className="table-responsive act_card tdAct ">
              <table className="table table-vertical mb-0">
                <thead>
                  <tr>
                    <th>Member Name</th>
                    <th style={{ marginLeft: 10 }}>Total Time</th>
                    <th>Total Percent</th>
                  </tr>
                </thead>
                <tbody className="table_scroll">
                  {todayAct?.rows?.map((act, idx) => (
                    <tr key={idx}>
                      <td>
                        <div className="d-flex align-items-center">
                          <span
                            className="border d-flex align-items-center justify-content-center rounded text-white bg-info toad_icon"
                            style={{
                              height: '30px',
                              width: '30px',
                              textTransform: 'uppercase',
                            }}
                          >
                            {act?.user?.firstName.charAt(0)}
                            {act?.user?.lastName.charAt(0)}
                          </span>
                          <span className="act_name ml-1">
                            {act?.user?.firstName} {act?.user?.lastName}
                          </span>
                        </div>
                      </td>
                      {/* <td>06:20</td> */}
                      <td>
                        <p className="time_border2">
                          {convertSeconds(act?.totalTime)}
                        </p>
                      </td>
                      <td className="text-end">
                        <p className="text_style2 text-center">
                          {act?.completionPercent || 0} %
                        </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-center h-100">
              <button
                className="btn btn-primary font-14"
                onClick={() => fetchDashboardData(true)}
              >
                Load Data
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WeekActivity;
